/**
 * Release flags of the Explorer build (adopt-trunk-based-development design D7, RNF-ARQ-14): the
 * same `<module>.<flag>` names as the server's `STRUST_RELEASE_FLAGS`, set per installation at build
 * time (`VITE_RELEASE_FLAGS`). A screen behind an off flag is not routed and nothing links to it.
 */
export type HubReleaseFlag = "iam.password-reset" | "fleet.console";

/** The flags switched on in a comma-separated list (blanks and unknown names are ignored). */
export function parseReleaseFlags(raw: string | undefined): ReadonlySet<HubReleaseFlag> {
  const known: readonly HubReleaseFlag[] = ["iam.password-reset", "fleet.console"];
  const on = new Set<HubReleaseFlag>();
  for (const name of (raw ?? "").split(",").map((part) => part.trim()))
    for (const flag of known) if (flag === name) on.add(flag);
  return on;
}

/** Whether the flag is on in this build. */
export function isReleaseFlagOn(flag: HubReleaseFlag): boolean {
  return parseReleaseFlags(import.meta.env.VITE_RELEASE_FLAGS).has(flag);
}
